<script setup lang="ts">
import CloseIcon from '@/assets/icons/CloseIcon.vue';
import { useSchoolSubject } from '@/composables/schoolSubject/useSchoolSubject';
import CompetenceDisplayRow from '@/core/competences/CompetenceDisplayRow.vue';
import { toSelectedCompetenceDisplayItem } from '@/core/competences/competenceDisplay.utils';
import type { ISelectedCompetence } from '@/interfaces';
import { computed } from 'vue';

const emit = defineEmits<{ remove: [] }>();

const props = withDefaults(
  defineProps<{
    disabled?: boolean;
    removable?: boolean;
    selectedCompetence: ISelectedCompetence;
  }>(),
  { disabled: false, removable: true },
);

const { getSchoolSubjectColor } = useSchoolSubject();
const displayItem = computed(() => toSelectedCompetenceDisplayItem(props.selectedCompetence, getSchoolSubjectColor));
</script>

<template>
  <CompetenceDisplayRow :item="displayItem">
    <template v-if="$slots.trailing || props.removable" #trailing>
      <slot name="trailing" />
      <button
        v-if="props.removable"
        type="button"
        class="!ml-sm flex size-8 shrink-0 items-center justify-center rounded-full text-secondary state-effects"
        :disabled="props.disabled"
        :aria-label="$t('competence.remove')"
        @click="emit('remove')"
      >
        <CloseIcon class="size-icon-sm" />
      </button>
    </template>
  </CompetenceDisplayRow>
</template>
